import { Controllers } from 'lib/enums/routes/_controllers';
import { TransactionsRoutes } from 'lib/enums/routes/transactions';
import {
  TransactionDoc,
  TransactionWhole,
} from 'lib/interfaces/database/transaction';
import { BaseService } from 'services/_base';

export class TransactionsService extends BaseService {
  private static instance: TransactionsService;

  static getInstance(): TransactionsService {
    if (!TransactionsService.instance) {
      TransactionsService.instance = new TransactionsService();
    }

    return TransactionsService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.transactions,
    });
  }

  search(payload: Partial<TransactionDoc>) {
    return this.POST(
      {
        uri: TransactionsRoutes.Search,
      },
      payload
    )
      .then((result: TransactionWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: Partial<TransactionDoc>) {
    return this.POST(
      {
        uri: TransactionsRoutes.CreateOne,
      },
      payload
    )
      .then((result: TransactionWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<TransactionDoc>) {
    return this.PUT(
      {
        uri: `${TransactionsRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: TransactionWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  // the record will remain but the deleted flag will be set to true
  markDeleted(id: string) {
    return this.DELETE({
      uri: `${TransactionsRoutes.DeleteOne}/${id}`,
    })
      .then((result: TransactionWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
